export const trouserRack = [
    {
        name: 'gt_60',
        height: 0.1,
        width: 0.6,
        depth: 0.1,
    },
    {
        name: 'gt_45',
        height: 0.1,
        width: 0.45,
        depth: 0.1,
    },
];

export const defaultTrouserRackOffsets = [ 0,-0.011, -0.005 ] as const;
